/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The full ordered problem list of a competition; the list index becomes the ordinal.
 * @export
 * @interface CompetitionProblemsReplace
 */
export interface CompetitionProblemsReplace {
    /**
     * 
     * @type {Array<string>}
     * @memberof CompetitionProblemsReplace
     */
    problem_ids: Array<string>;
}

/**
 * Check if a given object implements the CompetitionProblemsReplace interface.
 */
export function instanceOfCompetitionProblemsReplace(value: object): value is CompetitionProblemsReplace {
    if (!('problem_ids' in value) || value['problem_ids'] === undefined) return false;
    return true;
}

export function CompetitionProblemsReplaceFromJSON(json: any): CompetitionProblemsReplace {
    return CompetitionProblemsReplaceFromJSONTyped(json, false);
}

export function CompetitionProblemsReplaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionProblemsReplace {
    if (json == null) {
        return json;
    }
    return {
        
        'problem_ids': json['problem_ids'],
    };
}

export function CompetitionProblemsReplaceToJSON(json: any): CompetitionProblemsReplace {
    return CompetitionProblemsReplaceToJSONTyped(json, false);
}

export function CompetitionProblemsReplaceToJSONTyped(value?: CompetitionProblemsReplace | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'problem_ids': value['problem_ids'],
    };
}

